import * as React from 'react'
import type { SVGProps } from 'react'
export const MicrosoftLogo = (
  props: SVGProps<SVGSVGElement> & {
    fill?: string
    stroke?: string
  },
) => (
  <svg
    viewBox='0 0 256 256'
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    preserveAspectRatio='xMidYMid'
    {...props}
  >
    <path fill={props.fill ?? '#F1511B'} d='M121.666 121.666H0V0h121.666z' />
    <path fill={props.fill ?? '#80CC28'} d='M256 121.666H134.335V0H256z' />
    <path
      fill={props.fill ?? '#00ADEF'}
      d='M121.663 256.002H0V134.336h121.663z'
    />
    <path
      fill={props.fill ?? '#FBBC09'}
      d='M256 256.002H134.335V134.336H256z'
    />
  </svg>
)
